import { ContactEmergency, PermContactCalendar } from "@mui/icons-material";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Collapse,
  Stack,
  Typography,
  Zoom,
} from "@mui/material";
import { green, grey } from "@mui/material/colors";
import { useState } from "react";

function Userprofile() {
  const [openProfile, setOpenProfile] = useState(false);
  const [openCard, setOpenCard] = useState(false);

  return (
    <Zoom in={true} style={{ transitionDelay: "200ms" }}>
      <Stack display={'flex'} rowGap={2}>
        <Card>
          <CardContent>
            <Box
              display={"flex"}
              flexDirection={"column"}
              bgcolor={green[400]}
              borderRadius={4}
              height={200}
            >
              <Box display={"flex"} justifyContent={"center"}>
                <Avatar
                  src="https://images.pexels.com/photos/774909/pexels-photo-774909.jpeg?auto=compress&cs=tinysrgb&w=600"
                  alt="User"
                  sx={{ height: 128, width: 128, mt: 2 }}
                ></Avatar>
              </Box>
              <Box display={"flex"} justifyContent={"center"}>
                <Typography variant="h6" color={grey[100]}>
                  My Username
                </Typography>
              </Box>
            </Box>
            <Box display={"flex"} justifyContent={"center"}></Box>
          </CardContent>
          <CardActions sx={{ justifyContent: "end" }}>
            <Button
              startIcon={<ContactEmergency />}
              size="small"
              variant="contained"
              onClick={() => setOpenProfile(!openProfile)}
            >
              Profile
            </Button>
            <Button
              startIcon={<PermContactCalendar />}
              size="small"
              variant="contained"
              onClick={() => setOpenCard(!openCard)}
            >
              My Card
            </Button>
          </CardActions>
        </Card>
        <Collapse in={openProfile} timeout="auto" unmountOnExit>
          <Stack>
            <Card>
              <CardContent>
                <Typography>My Profile</Typography>
              </CardContent>
            </Card>
          </Stack>
        </Collapse>
        <Collapse in={openCard} timeout="auto" unmountOnExit>
          <Stack>
            <Card>
              <CardContent>
                <Typography>My Card</Typography>
              </CardContent>
            </Card>
          </Stack>
        </Collapse>
      </Stack>
    </Zoom>
  );
}

export default Userprofile;
